import { base, baseSepolia } from 'viem/chains';
////////////////////////////////////////////////////////////
// from @aa-sdk gasManager.ts
////////////////////////////////////////////////////////////
export const AlchemyPaymasterAddressV06Unify = '0x0000000000ce04e2359130e7d0204A5249958921';
export const AlchemyPaymasterAddressV07Unify = '0x00000000000667F27D4DB42334ec11a25db7EBb4';
export const AlchemyPaymasterAddressV4 = '0xEaf0Cde110a5d503f2dD69B3a49E031e29b3F9D2';
export const AlchemyPaymasterAddressV3 = '0x4f84a207A80c39E9e8BaE717c1F25bA7AD1fB08F';
export const AlchemyPaymasterAddressV2 = '0x4Fd9098af9ddcB41DA48A1d78F91F1398965addc';
export const ArbSepoliaPaymasterAddress = '0x0804Afe6EEFb73ce7F93CD0d5e7079a5a8068592';
export const AlchemyPaymasterAddressV1 = '0xc03aac639bb21233e0139381970328db8bceeb67';
export const AlchemyPaymasterAddressV07V2 = '0x2cc0c7981D846b9F2a16276556f6e8cb52BfB633';
export const AlchemyPaymasterAddressV07V1 = '0xEF725Aa22d43Ea69FB22bE2EBe6ECa205a6BCf5B';
/**
 * Retrieves the Alchemy paymaster address for the given chain. Returns different addresses based on the chain ID.
 *
 * @example
 * ```ts
 * import { sepolia, getAlchemyPaymasterAddress } from "@account-kit/infra";
 *
 * const paymasterAddress = getAlchemyPaymasterAddress(sepolia, "0.6.0");
 * ```
 *
 * @param {Chain} chain The chain for which the paymaster address is required
 * @param {EntryPointVersion} version The version of the entry point
 * @returns {Address} The Alchemy paymaster address corresponding to the specified chain
 */
export const getAlchemyPaymasterAddress = (chain, version) => {
    switch (version) {
        case '0.6':
        case '0.6.0':
            switch (chain.id) {
                case baseSepolia.id:
                    return AlchemyPaymasterAddressV3;
                case base.id:
                    return AlchemyPaymasterAddressV2;
                default:
                    throw new Error(`Unsupported chain: ${chain.id}`);
            }
        case '0.7':
        case '0.7.0':
            switch (chain.id) {
                case base.id:
                case baseSepolia.id:
                    return AlchemyPaymasterAddressV07V2;
                default:
                    throw new Error(`Unsupported chain: ${chain.id}`);
            }
        default:
            throw new Error(`Unsupported EntryPointVersion`);
    }
};
